

var _angular = require('angular');

var _uiRouter = require('uiRouter');

var _logger = require('xo-beaver/dist/logger');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

var _bml = require('xo-models/src/bml');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$BMLStateHandler', function () {
    var APPROVED = 'APPROVED';
    var SOFT_DECLINED = 'SOFT_DECLINED';
    var DECLINED = 'DECLINED';
    var FUNDING_INSTRUMENT_ASSOCIATED_WITH_DIFFERENT_MEMBER = 'FUNDING_INSTRUMENT_ASSOCIATED_WITH_DIFFERENT_MEMBER';
    var NEED_SIGNATURE = 'NEED_SIGNATURE';
    var PENDING_COMPLETION_STATUS = 'PENDING_COMPLETION_STATUS';
    var FULL_APPLY_REQUIRED = 'FULL_APPLY_REQUIRED';
    var UNKNOWN_DECISION = 'UNKNOWN_DECISION';
    var INELIGIBLE = 'INELIGIBLE'; // TODO; This state is returned by applybml but was not defined in Aries
    var MAX_SOFT_DECLINES = config.bmlMaxSoftDeclines; // eslint-disable-line block-scoped-var,no-undef

    var BMLStateHandler = function BMLStateHandler(bmlData) {
        this.reviewUrl = bmlData.reviewUrl;
        this.bml = bmlData.bml;
        this.bmlApply = bmlData.bmlApply;
        this.bmlComplete = bmlData.bmlComplete;
        this.checkoutSession = bmlData.checkoutSession;
        this.auth = bmlData.auth;
        this.purchase = bmlData.purchase;
        this.patchPhone = bmlData.patchPhone;
        this.billingAddresses = bmlData.billingAddresses;
        this.merchant = bmlData.merchant;
        this.merchantId = bmlData.merchantId;

        this.handlers = {};
        this.handlers[APPROVED] = this.handleAppStatusApproved;
        this.handlers[DECLINED] = this.handleAppStatusDeclined;
        this.handlers[SOFT_DECLINED] = this.handleAppStatusSoftDeclined;
        this.handlers[FUNDING_INSTRUMENT_ASSOCIATED_WITH_DIFFERENT_MEMBER] = this.handleAppStatusFundingInsExist;
        this.handlers[NEED_SIGNATURE] = this.handleAppStatusNeedSignature;
        this.handlers[PENDING_COMPLETION_STATUS] = this.handleAppStatusPendingCompletion;
        this.handlers[UNKNOWN_DECISION] = this.handleAppStatusUnknownDecision;
        this.handlers[FULL_APPLY_REQUIRED] = this.handleAppStatusFullApplyRequired;
        this.handlers[INELIGIBLE] = this.handleAppStatusIneligible;
    };

    BMLStateHandler.prototype.payInFullRedirect = function payInFullRedirect(result) {
        _logger.$logger.info('APPLYFORBML_VIEW_OPTOUTBML');
        _uiRouter.$state.go(this.reviewUrl);
    };

    BMLStateHandler.prototype.termsAndCondition = function termsAndCondition(result) {
        _uiRouter.$state.go('^.bmltermsandconditions');
    };

    BMLStateHandler.prototype.handleAppStatusIneligible = function handleAppStatusIneligible(result) {
        _logger.$logger.info('APPLYFORBML_INELIGIBLE');
        _logger.$logger.info('checkout_fpti', {
            'ppc_status': 'bmlIneligible'
        });
        this.checkoutSession.creditOffer = false;
        this.checkoutSession.showDeclinePopup = true;
        _uiRouter.$state.go(this.reviewUrl);
    };

    BMLStateHandler.prototype.handleAppStatusUnknownDecision = function handleAppStatusUnknownDecision(result) {
        _logger.$logger.info('APPLYFORBML_UNKNOWN_DECISION');
        _logger.$logger.info('checkout_fpti', {
            'ppc_status': 'bmlUnknownDecision'
        });
        this.checkoutSession.creditOffer = false;
        this.checkoutSession.showDeclinePopup = true;
        _uiRouter.$state.go(this.reviewUrl);
    };

    BMLStateHandler.prototype.handleAppStatusApproved = function handleAppStatusApproved(result) {
        _logger.$logger.info('APPLYFORBML_ACTION_BMLSUCCESS');
        _logger.$logger.info('checkout_fpti', {
            'ppc_status': 'bmlSuccess'
        });
        this.checkoutSession.fundingOptions.action('update', {
            resultModel: this.checkoutSession,
            data: {
                planId: this.bml.financial_instrument_id
            },
            success: $.proxy(function (successResult) {
                _uiRouter.$state.go(this.reviewUrl);
            }, this),
            contingencies: {
                DEFAULT: function DEFAULT(name) {
                    _uiRouter.$state.go(this.reviewUrl);
                }
            }
        });
    };

    BMLStateHandler.prototype.handleAppStatusPendingCompletion = function handleAppStatusPendingCompletion(result) {
        _logger.$logger.info('checkout_fpti', {
            'ppc_status': 'completeBmlApply'
        });
        this.completeApplication(result.application_id);
    };

    BMLStateHandler.prototype.handleAppStatusNeedSignature = function handleAppStatusNeedSignature(result) {
        _logger.$logger.info('APPLYFORBML_NEED_SIGNATURE');
        this.bml.application_id = result.application_id;
        _logger.$logger.info('checkout_fpti', {
            'ppc_status': 'needSignature'
        });
        _uiRouter.$state.go('^.bmlsignature');
    };

    BMLStateHandler.prototype.handleAppStatusDeclined = function handleAppStatusDeclined(result) {

        _logger.$logger.info('APPLYFORBML_ACTION_BMLDECLINEHARD');
        _logger.$logger.info('checkout_fpti', {
            'ppc_status': 'creditDeclineHard'
        });
        this.bml.application_status = 'DECLINED';
        this.checkoutSession.creditOffer = false;
        this.checkoutSession.showDeclinePopup = true;

        _uiRouter.$state.go(this.reviewUrl);
    };

    BMLStateHandler.prototype.handleAppStatusSoftDeclined = function handleAppStatusSoftDeclined(result) {

        this.bml.bmlSoftDeclineCtr = (this.bml.bmlSoftDeclineCtr || 0) + 1;
        if (this.bml.bmlSoftDeclineCtr < MAX_SOFT_DECLINES) {
            _logger.$logger.info('APPLYFORBML_ACTION_BMLDECLINESOFT');
            _uiRouter.$state.go('^.bmlapply');
        } else {
            _logger.$logger.info('checkout_fpti', {
                'ppc_status': 'bmlMaxAttempts'
            });
            _logger.$logger.info('APPLYFORBML_ACTION_BMLMAXATTEMPTS');
            this.bml.application_status = 'DECLINED';
            this.checkoutSession.creditOffer = false;
            this.checkoutSession.showDeclinePopup = true;

            _uiRouter.$state.go(this.reviewUrl);
        }
    };

    BMLStateHandler.prototype.handleAppStatusFundingInsExist = function handleAppStatusFundingInsExist(result) {
        _logger.$logger.info('APPLYFORBML_ACTION_BMLDECLINELINKEDTODIFFMEMBER');
        _logger.$logger.info('checkout_fpti', {
            'ppc_status': 'bmlDeclineLinkedToDiffMember'
        });
        this.checkoutSession.creditOffer = false;
        this.checkoutSession.showDeclinePopup = true;
        _uiRouter.$state.go(this.reviewUrl);
    };

    BMLStateHandler.prototype.handleAppStatusFullApplyRequired = function handleAppStatusFullApplyRequired(result) {
        _logger.$logger.info('APPLYFORBML_FULLAPPLYREQUIRED');
        _logger.$logger.info('checkout_fpti', {
            'ppc_status': 'fullApplyRequired'
        });
        this.checkoutSession.creditOffer = false;
        this.bml.fullApplyRequired = true;
        this.checkoutSession.showDeclinePopup = true;

        _uiRouter.$state.go(this.reviewUrl);
    };

    BMLStateHandler.prototype.handleBmlTransitions = function handleBmlTransitions(result) {
        var handler = this.handlers[result.application_status];
        if (!handler) {
            throw new Error('no registered handler for bml transition for application status ' + result.application_status);
        }
        return $.proxy(handler, this, result)();
    };

    BMLStateHandler.prototype.completeApplication = function completeApplication(application_id) {

        this.bmlComplete.application_id = application_id;
        this.bmlComplete.action('complete', {

            success: $.proxy(function (result) {
                _logger.$logger.info('COMPLETEBMLAPPLY_ACTION_BMLSUCCESS');
                var bml = this.bml;

                // Update the application_status & financial_instrument_id in bml model
                bml.setProperties({
                    financial_instrument_id: result.financial_instrument_id,
                    application_status: result.application_status
                });

                if (bml.phoneChanged && result && result.user_info && result.user_info.phones && result.user_info.phones.length > 0 && result.user_info.phones[0].id) {

                    var newPhoneVO = {
                        op: 'add',
                        path: '/payer_info',
                        value: {
                            phone: this.bmlApply.personalInformation.phone.telephone
                        }
                    };
                    this.patchPhone.save({
                        data: {
                            patch: newPhoneVO
                        },
                        success: $.proxy(function () {
                            delete bml.phoneChanged;
                            this.handleBmlTransitions(result);
                        }, this),
                        contingencies: {
                            DEFAULT: $.proxy(function handleContingency(name, contingency) {
                                _logger.$logger.info('BMLPATCHPHONE_CONTINGENCY', name);
                                this.handleBmlTransitions(result);
                            }, this)
                        }
                    });
                } else {
                    this.handleBmlTransitions(result);
                }
            }, this)
        });
    };

    BMLStateHandler.prototype.getDefaultBillingAddress = function getDefaultBillingAddress(billingAddresses) {
        var defaultBillingAddress = billingAddresses && billingAddresses.addresses;
        defaultBillingAddress = defaultBillingAddress.map(function (address, index, array) {
            if (address && address['default'] === true) {
                return address;
            }
        });

        defaultBillingAddress = defaultBillingAddress.length > 0 && defaultBillingAddress[0];
        return defaultBillingAddress;
    };

    BMLStateHandler.prototype.applyBML = function applyBML() {

        var defaultBillingAddress = this.getDefaultBillingAddress(this.billingAddresses);

        this.bml.action('apply', {
            data: {
                flow: {
                    nape: this.bml.nape,
                    fullApplyRequired: this.bml.fullApplyRequired
                },
                payer: {
                    email: this.checkoutSession.payer.email,
                    id: this.checkoutSession.payer.id,
                    phone: this.bmlApply.personalInformation.phone.telephone,
                    phone_type: this.bmlApply.personalInformation.phone.phoneType
                },
                billing_address: {
                    line1: defaultBillingAddress.line1,
                    line2: defaultBillingAddress.line2,
                    city: defaultBillingAddress.city,
                    state: defaultBillingAddress.state,
                    postal_code: defaultBillingAddress.postal_code,
                    country: defaultBillingAddress.country,
                    id: defaultBillingAddress.id
                },
                payment_info: {
                    total_transaction_amount: {
                        value: this.purchase.amounts.total.amount,
                        currency: this.purchase.amounts.total.currency_code
                    },
                    recipient: {
                        id: this.merchantId,
                        total_amount: {
                            value: this.purchase.amounts.total.amount,
                            currency: this.purchase.amounts.total.currency_code
                        },
                        business_name: this.merchant.brand_name,
                        type: 'PAYPAL_CORE',
                        multi_seller_indicator: false,
                        country_code: this.merchant.merchant_country
                    },
                    shipping_address: {
                        id: this.checkoutSession.shipping.id,
                        name: this.checkoutSession.shipping.name,
                        line1: this.checkoutSession.shipping.line1,
                        line2: this.checkoutSession.shipping.line2,
                        city: this.checkoutSession.shipping.city,
                        state: this.checkoutSession.shipping.state,
                        country_code: this.checkoutSession.shipping.country,
                        postal_code: this.checkoutSession.shipping.postal_code,
                        'default': this.checkoutSession.shipping['default']
                    },
                    name: {
                        first_name: this.auth.first_name,
                        last_name: this.auth.last_name
                    },
                    item_info: this.purchase.items
                },
                dobSsn: {
                    dobMonth: this.bmlApply.personalInformation.month,
                    dobDay: this.bmlApply.personalInformation.day,
                    dobYear: this.bmlApply.personalInformation.year,
                    nationalId: this.bmlApply.personalInformation.natId
                }
            },

            resultModel: this.bml,

            success: $.proxy(function (result) {
                this.handleBmlTransitions(result);
            }, this),

            contingencies: {
                DEFAULT: $.proxy(function handleContingency(name, contingency) {
                    this.bml.contingency = name;
                    this.checkoutSession.creditOffer = false;
                    this.checkoutSession.showDeclinePopup = true;
                    _uiRouter.$state.go(this.reviewUrl);
                }, this)
            }
        });
    };
    return BMLStateHandler;
}).directive('xoBmlDisplay', function () {
    return {
        template: _template2['default'],
        scope: {
            reviewUrl: '=?'
        },
        controller: ['$scope', function ($scope) {
            if (!_angular.$rootScope.bml && !_angular.$rootScope.bmlApply) {
                $scope.bml = new _bml.$BMLModel();
                $scope.bmlApply = new _bml.$ApplyForBMLModel();
            } else {
                $scope.bml = _angular.$rootScope.bml;
                $scope.bmlApply = _angular.$rootScope.bmlApply;
            }
            $scope.bmlComplete = new _bml.$BMLApplicationModel();
            _uiRouter.$state.go('^.bmlapply');
        }]
    };
});

_angular.$rootScope;

_uiRouter.$state;

_logger.$logger;

_bml.$BMLModel;

_bml.$ApplyForBMLModel;

_bml.$BMLApplicationModel;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-credit-components/src/bml-display/directive.js
// module id = ../node_modules/xo-credit-components/src/bml-display/directive.js
// module chunks = 0